export default "__VITE_ASSET__Dj9VW02T__"